import * as yup from 'yup'

const schema = yup.object().shape({
  tipoMonta: yup.string().required('Selecione um tipo de monta.'),
  idFazenda: yup.string().required('Fazenda é obrigatório.'),
  idVaca: yup.string().required('Vaca é obrigatório.'),
  idTouro: yup.string(),
  dataInicio: yup.date().nullable().typeError('Data de início é obrigatória'),
  dataFim: yup.date().nullable().typeError('Data de fim é obrigatória')
})

export default schema
